import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".Dropdown-module_dropdownMenu__nW9YH {\n  transform: none !important;\n  top: 100% !important;\n}";
var Styles = {"dropdownMenu":"Dropdown-module_dropdownMenu__nW9YH"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=Dropdown.module.scss.js.map
